<template lang="pug">
  y-dialog(v-model="showDialog" :fullscreen="$vuetify.breakpoint.xsOnly" max-width="600" persistent scrollable content-class="round-3xl")
    v-card
      v-card-title.pa-4
        v-row(no-gutters align="center")
          v-col(cols="10" offset="1")
            div.text-xl.font-bold.neutral700--text.text-center {{ $t('edit_booking_details') }}
          v-col(cols="1" align="right")
            v-btn.ml-n3(text icon @click="closeDialog")
              v-icon(color="neutral700" :size="24") mdi-close
      v-divider
      v-card-text(:class="$vuetify.breakpoint.xsOnly ? 'pa-4' : 'pa-8'")
        div.text-md.font-semibold.neutral700--text {{ $t('make_change_on_details') }}
        v-form(ref="form")
          div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('name') }}
          v-text-field.text-sm.mt-2.round-xl(v-model="lead.name" :placeholder="$t('name')" outlined dense height="48" :rules="rules.not_empty" hide-details="auto")
          div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('phone') }}
          phone-input.mt-2(ref="phoneInput" v-model="lead.phone")
          div.text-sm.font-semibold.neutral500--text.mt-4 {{ $t('email') }}
          v-text-field.text-sm.mt-2.round-xl(v-model="lead.email" :placeholder="$t('email_optional')" outlined dense height="48" hide-details="auto" :rules="Boolean(lead.email) ? rules.valid_email : []")

      v-divider
      v-card-actions.py-4(:class="$vuetify.breakpoint.xsOnly ? 'px-4' : 'px-8'")
        v-btn.button-md.neutral700--text.px-0(@click="closeDialog" text) {{ $t('cancel') }}
        v-spacer
        v-btn.button-md(:loading="isLoading" color="neutral700" dark depressed @click="saveData") {{ $t('save') }}

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PhoneInput from '@/components/clinic/custom/PhoneInput.vue'

export default {
  components: { PhoneInput },
  props: ['open', 'selectedAppointment'],
  data () {
    return {
      isFetching: false,
      isLoading: false,
      lead: null,
      initialData: null,
      rules: {
        not_empty: [v => (v != null && v.toString().trim().length) || 'This field is required'],
        has_quantity: [v => !!v || 'This field is required', v => v != 0 || 'This field is required'],
        has_price: [(v) => !!v || 'This field is required', (v) => v >= 1|| `Amount should be more than ${this.$currency.symbol} 1`],
        not_empty_select: [v => !!v || 'This field is required'],
        valid_email: [ v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid', ]
      },
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    showDialog: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    },
    hasChanges () {
      if (this.tempAppointment && this.tempAppointment.patient) {
        let patient = {
          name: this.tempAppointment.patient.name,
          phone: this.tempAppointment.patient.phone,
          email: this.tempAppointment.patient.email,
          ic: this.tempAppointment.patient.ic,
        }
        if (!this.checkEmptyAddress(this.tempAppointment.address)) {
          patient.address = {
            address_1: this.tempAppointment.address.address_1,
            address_2: this.tempAppointment.address.address_2,
            postcode: this.tempAppointment.address.postcode,
            city: this.tempAppointment.address.city,
            state: this.tempAppointment.address.state,
            country: this.tempAppointment.address.country,
            name: this.tempAppointment.address.name,
            phone: this.tempAppointment.address.phone
          }
        }
        return JSON.stringify(this.initialData) !== JSON.stringify(patient)
      }
      return false
    }
  },
  mounted () {
    this.lead = JSON.parse(JSON.stringify(this.selectedAppointment.lead))
  },
  methods: {
    ...mapActions(['showMessage']),
    saveData () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      let data = {
        name: this.lead.name,
        phone: this.lead.phone,
        email: this.lead.email
      }
      this.$axios.patch(`/leads/${this.lead.pid}`, data)
        .then(() => {
          this.closeResetDialog()
        })
        .catch(err => {
          let message = this.$t('error_message.unable_to_complete_request')
          if (err.response.data?.detail) {
            message = err.response.data.detail
          }
          this.showMessage(['error', message])
          this.isLoading = false
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    closeResetDialog () {
      this.showDialog = false
      this.$emit('reset')
    },
    closeDialog () {
      this.showDialog = false
    },
    checkEmptyAddress (address) {
      if (!address) {
        return true
      }
      if (Object.keys(address).length === 0) {
        return true
      } else if (Object.values(address).every(val => !val)) {
        return true
      }
      return false
    },
    getAddressInString (addr) {
      let address = ''
      if (addr.address_1) {
        address += addr.address_1
      } if (addr.address_2) {
        address += `, ${addr.address_2}`
      } if (addr.postcode) {
        address += `, ${addr.postcode}`
      } if (addr.city) {
        address += `, ${addr.city}`
      } if (addr.state) {
        address += `, ${addr.state}`
      } if (addr.country) {
        address += `, ${addr.country}`
      }
      return address
    },
    copyText (text) {
      let container = this.$refs.copy
      this.$copyText(text, container)
        .then(() => {
          this.showMessage(['success', this.$t('success_message.content_copied_to_clipboard')])
        })
    }
  },
  destroyed () {
    this.$store.commit('clinic/resetTempAppointment')
  }
}
</script>

<style scoped>
</style>